var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeviceActionDownloadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "xMidYMid meet",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 14.3978 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.3978 20.7179C14.3978 20.4143 14.0995 20.1683 13.7312 20.1683C10.6851 20.1683 3.7604 20.1683 0.714286 20.1683C0.345952 20.1683 0.0476123 20.4143 0.0476123 20.7179C0.0476123 20.9496 0.0476123 21.2188 0.0476123 21.4505C0.0476123 21.7541 0.345952 22 0.714286 22C3.7604 22 10.6851 22 13.7312 22C14.0995 22 14.3978 21.7541 14.3978 21.4505C14.3978 21.2188 14.3978 20.9496 14.3978 20.7179Z",
    fill: "var(--fill-0, #009BE5)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.20082 12.2031C8.20082 12.6181 8.72772 12.8169 9.02309 12.5144C10.0341 11.4791 11.7139 9.75885 12.5126 8.94091C12.6321 8.81848 12.7935 8.75023 12.9617 8.75023C13.1299 8.75023 13.2912 8.81848 13.4108 8.94091C13.6261 9.16139 13.8842 9.42575 14.0995 9.64623C14.2191 9.76866 14.2857 9.93388 14.2857 10.1061C14.2857 10.2784 14.2191 10.4436 14.0995 10.5661C12.7786 11.9187 8.91284 15.8776 7.59196 17.2303C7.34387 17.4844 6.94184 17.4844 6.69375 17.2303C5.37288 15.8776 1.50707 11.9187 0.186197 10.5661C0.0666466 10.4436 0 10.2784 0 10.1061C0 9.93388 0.0666466 9.76866 0.186197 9.64623C0.401493 9.42575 0.659638 9.16139 0.874934 8.94091C0.994485 8.81848 1.15582 8.75023 1.32404 8.75023C1.49226 8.75023 1.6536 8.81848 1.77315 8.94091C2.57186 9.75885 4.25162 11.4791 5.26262 12.5144C5.558 12.8169 6.08489 12.6148 6.08489 12.1999V0.650068C6.08489 0.477802 6.15155 0.312579 6.27057 0.19015C6.39012 0.0682636 6.55146 0 6.71968 0C6.98734 0 7.29837 0 7.56604 0C7.73425 0 7.89559 0.0682636 8.01514 0.19015C8.13417 0.312579 8.20082 0.477802 8.20082 0.650068C8.20082 2.99032 8.20082 9.19445 8.20082 12.2031Z",
    fill: "var(--fill-0, #009BE5)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeviceActionDownloadIcon);
export default __webpack_public_path__ + "static/media/DeviceActionDownloadIcon.afa6f27907daef90a85d6790d9d7c85e.svg";
export { ForwardRef as ReactComponent };